import { render, staticRenderFns } from "./PerfDataTabs.vue?vue&type=template&id=7b09ae96&scoped=true&"
import script from "./PerfDataTabs.vue?vue&type=script&lang=js&"
export * from "./PerfDataTabs.vue?vue&type=script&lang=js&"
import style0 from "./PerfDataTabs.vue?vue&type=style&index=0&id=7b09ae96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b09ae96",
  null
  
)

export default component.exports